<template>
  <div class="company">
    <div class="company_card">
      <div class="video">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          name="videoPlayer"
          id="video"
          :playsinline="true"
          :options="playerOptions"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
          @waiting="onPlayerWaiting($event)"
          @timeupdate="onPlayerTimeupdate($event)"
          @statechanged="playerStateChanged($event)"
          @canplaythrough="onPlayerCanplaythrough($event)"
          @ready="playerReadied"
        ></video-player>
      </div>
      <div class="text">
        <div class="textLine"></div>
        <div class="textTitle">{{ playerOptions.title }}</div>
        <div class="textContent">{{ playerOptions.content }}</div>
      </div>
    </div>
    <div class="company_list">
      <div class="leftBtn" @click="clickLeftBtn">
        <img src="@/assets/image/About/company/leftBtn.png" alt="">
      </div>
      <div class="videoList">
        <div class="videoItem" v-for="(item,index) in videoList" :key="index"
             :class="{'videoItemSelect':item.src === playerOptions.sources[0].src}"
             @click="item.src === playerOptions.sources[0].src ?'': videoItemClick(item, index) ">
          <img class="coverImage" :src="item.image" alt="">
          <img class="play" src="@/assets/image/About/company/playBtn.png" alt="">
        </div>
      </div>
      <div class="rightBtn"  @click="clickRightBtn">
        <img src="@/assets/image/About/company/rightBtn.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>

import {videoPlayer} from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

export default {
  name: "company",
  components: {
    videoPlayer
  },
  data() {
    return {
      currentVideoIdx: 0,
      playTime: '',
      current: '',
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src:
              "https://images.pxb7.com/video/nianhui.mp4", // url地址
          },
          {
            type: "video/mp4", // 类型
            src:
              "https://images.pxb7.com/video/nianhui2022.mp4", // url地址
          }
        ],
        poster: "", // 封面地址
        title:'',
        content:'',
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        },
      },

      videoList: [
        {
          type: "video/mp4", // 类型
          src: "https://images.pxb7.com/video/nianhui2022.mp4", // url地址
          image: 'https://images.pxb7.com/video/nianhui2022.jpg',
          title:'2022公司年会',
          content:'2022年是游严选迅速发展的一年，下半年每月游严选注册人数以10万计数增长，官网日活超500万次。',
        },
        {
          type: "video/mp4", // 类型
          src: "https://images.pxb7.com/video/nianhui.mp4", // url地址
          image: 'https://images.pxb7.com/images/upload/image/20220129/1643426896443646.png',
          title:'2021公司年会',
          content:'从公司最初由创始人一个人带着两个员工独立创业开始，用了三年时间发展到目前累计成交订单超100000笔，为数十万客户提供过直接服务。',
        },
      ]
    };
  },
  beforeRouteLeave() {
    this.$refs.videoPlayer.player.pause()
  },
  methods: {
    clickLeftBtn() {
      if(this.currentVideoIdx === 0){
        return
      }
      this.currentVideoIdx -= 1
      this.videoItemClick(this.videoList[this.currentVideoIdx], this.currentVideoIdx)
    },
    clickRightBtn() {
      if(this.videoList.length <= this.currentVideoIdx + 1){
        return
      }
      this.currentVideoIdx += 1
      this.videoItemClick(this.videoList[this.currentVideoIdx], this.currentVideoIdx)
    },
    // 播放回调
    onPlayerPlay(player) {
      // console.log("player play!", player);
    },

    // 暂停回调
    onPlayerPause(player) {
      // console.log("player pause!", player);
    },

    // 视频播完回调
    onPlayerEnded($event) {
      // console.log(player);
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting(player) {
      let time = localStorage.getItem("cacheTime")
      if (player.cache_.currentTime - Number(time) > 0.1) {
        this.current = Number(time)
        this.playerReadied(player)
      } else {
        this.current = player.cache_.currentTime
      }
    },

    // 已开始播放回调
    onPlayerPlaying($event) {
      // console.log(player)
    },

    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata($event) {
      // console.log(player)
    },

    // // 当前播放位置发生变化时触发。
    onPlayerTimeupdate(player) {
      this.playTime = player.cache_.currentTime
      let playTime = player.cache_.currentTime
      setTimeout(function () {
        localStorage.setItem("cacheTime", playTime)
      }, 500)
      if (player.cache_.currentTime - Number(playTime) > 2) {
        this.current = Number(playTime)
        this.playerReadied(player)
      } else {
        this.current = player.cache_.currentTime
      }
    },

    //媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },

    //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },

    //播放状态改变回调
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied(player) {
      // console.log('example player 1 readied', player);
      player.currentTime(this.current)
    },
    playerReadied1(player) {
      // console.log('example player 1 readied', player);
    },

    /**
     * 点击播放视频
     * @param item 视频
     */
    videoItemClick(item, idx) {
      this.currentVideoIdx = idx || 0
      localStorage.setItem("cacheTime", 0)
      this.current = 0
      this.playerOptions.sources = []
      this.playerOptions.title = item.title
      this.playerOptions.content = item.content
      this.playerOptions.sources.push(item)
      this.playerOptions.autoplay = true
    },
  },
  created() {
    this.videoItemClick(this.videoList[0])
  }
}
</script>

<style scoped lang="less">

.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 3.0em;
  /* border-radius: 50%; */
  height: 283px !important;
  line-height: 283px !important;
  //margin-top: -1em !important;
}

/*这里用了第三方vue-video-player插件，但这个插件有bug，设置globalSetting:{controls:true}隐藏进度条不生效，故可设置插件样式进行隐藏vjs-progress-contro*/
.vjs-progress-control {
  visibility: hidden; // 隐藏进度条
}

.company {
  height: calc(100% - 120px);
  background: linear-gradient(180deg, #1A1D24, #25292d 100%);
  padding: 45px 33px 75px;

  .company_card {
    background: url("../../assets/image/About/company/cardBG.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 30px;

    .video {
      width: 511px;
      height: 283px;
      margin: 0 31px 0 0;

      .video-player {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      padding: 29px 0;

      .textLine {
        width: 64px;
        height: 1px;
        background: #ffffff;
        margin: 0 0 17px;
      }

      .textTitle {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: LEFT;
        color: #ffffff;
        margin: 0 0 10px;
      }

      .textContent {
        width: 286px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #ffffff;
        line-height: 29px;
      }

    }

  }

  .company_list {
    margin: 21px 0 0;
    display: flex;
    flex-direction: row;
    align-items: center;

    .leftBtn, .rightBtn {
      width: 15px;
      height: 29px;
    }

    .videoList {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 819px;

      .videoItem {
        width: 152px;
        height: 84px;
        padding: 5px 5px;
        margin: 0 7px;
        position: relative;

        .coverImage {
          width: 100%;
          height: 100%;
        }
        .play{
          width: 18px;
          height: 18px;
          position: absolute;
          top: 37%;
          left: 45%;
        }
      }

      .videoItemSelect {
        border: 3px solid #ffffff;
        padding: 2px 2px;
      }

    }

  }

}

</style>
